export default __webpack_public_path__ + "static/media/covid19.7d25efa6.png";